import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BookingsLogComponent } from './bookings-log/bookings-log.component';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full'
    },
    {
        path: 'list',
        component: BookingsLogComponent,
    },


];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class BookingsRoutingModule { }
